import { useState } from 'react';

import { notify } from '../../shared';
import { getContactState } from '../../api';
import { useFetch, useModal } from '../../hooks';
import type { ContactStateType } from '../../api';

export const useViewContactState = () => {
  const { isOpened, onOpen, onClose } = useModal();

  const [contactId, setContactId] = useState<string | undefined>(undefined);
  const { data, loading } = useFetch<ContactStateType[] | null>(
    () => (contactId ? getContactState(contactId) : null),
    [contactId],
    {
      skip: !contactId,
      initialLoading: false,
      onSuccess: () => onOpen(),
      onError: () => {
        onClose();
        notify.error('There was an error getting state');
      },
    }
  );

  const handleClose = () => {
    onClose();
    setContactId(undefined);
  };

  return {
    isOpened,
    loading,
    contactId,
    state: data,

    onClose: handleClose,
    handleView: (contactId: string) => setContactId(contactId),
  };
};

export type { ContactStateType };
